import { render, staticRenderFns } from "./ListMinhasReservas.vue?vue&type=template&id=74fdaefc&"
import script from "./ListMinhasReservas.vue?vue&type=script&lang=js&"
export * from "./ListMinhasReservas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports